import { OptionValue } from "@bluframe/blublocks"
import {
  AutosuggestProps,
  HomeVideoReviewSearchItem
} from "@bluframe/mightychroma-mightytool-frontend-types"
import { Props as SelectProps } from "components/inputs/Select"
import { ChangeEvent } from "react"

import Roundup from "./Roundup"

export interface Props {
  characters: SelectProps["options"]
  characterId: OptionValue | null
  homeVideoReviewIds: string[]
  homeVideoReviewTitles: HomeVideoReviewSearchItem[]
  isAutoSuggestLoading: boolean
  isCharactersLoading: boolean
  isGenerateBlogRoundupEnabled: boolean
  isGenerateBlogRoundupLoading: boolean
  onChangeCharacterId: SelectProps["onChange"]

  onChangeTheme: (event: ChangeEvent<HTMLInputElement>) => void
  onClickGenerate: () => void
  onGetSuggestions: AutosuggestProps["onGetSuggestions"]

  onSelectHomeVideoReviewId: (index: number) => (
    id: string,

    name: string
  ) => void
  reviewNames: string[]
  theme: string
}

export interface ComponentProps extends Props {}

export default Roundup
